










import { defineComponent } from "@vue/composition-api";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import providers from "@/lib/api";
import PurchaseConfirmationView from "./PurchaseConfirmationView.vue";

export default defineComponent({
  name: "PurchaseConfirmation",
  components: { PurchaseConfirmationView },
  props: {
    value: { type: Boolean, required: true },
    packageId: { type: String, required: true },
  },
  data() {
    return {
      paymentPackages: [] as PaymentPackage[],
    };
  },
  watch: {
    async value(currentValue: boolean) {
      if (currentValue && this.paymentPackages.length === 0) {
        this.paymentPackages = await providers.PaymentPackageProvider.findAll({
          type: [PaymentPackageEnum.MESSAGE_ATTACHMENT],
        });
      }
    },
  },
});
